import React from 'react';

import { Collapse, List, ListItem } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';

const HackApp = ({ data }) => {
    const { hackapp } = data;

    if (!hackapp) {
        return false;
    }

    const getBugItem = (name, data) => {
        if (!data.length) {
            return;
        }

        const cls = {
            critical: { className: 'vulners-background-red', name: 'CRITICAL' },
            medium: { className: 'vulners-background-yellow', name: 'MEDIUM' },
            notice: { className: 'vulners-background-grey', name: 'NOTICE' }
        };

        return (
            <>
                <ListItem key={name} className={cls[name].className}>
                    <ListItemText primary={cls[name].name} />
                </ListItem>
                <Collapse in={true} timeout="auto" unmountOnExit>
                    {data.map(function (bug) {
                        return (
                            <ListItem key={bug.id}>
                                <ListItemText primary={bug.name} secondary={bug.description} />
                            </ListItem>
                        );
                    })}
                </Collapse>
            </>
        );
    };

    const getBugs = (bugs) => {
        const vector = {
            critical: '',
            medium: '',
            notice: ''
        };

        bugs.forEach(function (bug) {
            if (!vector[bug.severity]) {
                vector[bug.severity] = [];
            }
            vector[bug.severity].push(bug);
        });

        return (
            <List>
                {Object.keys(vector).map((k) => {
                    return getBugItem(k, vector[k]);
                })}
            </List>
        );
    };

    return (
        <div>
            <h4>Name</h4>
            {hackapp.name}
            <br />
            <h4>Vendor</h4>
            {hackapp.vendor}
            <br />
            <h4>Link</h4>
            <a href={hackapp.link} rel="nofollow noreferrer" target="_blank">
                {hackapp.apk}
            </a>
            <br />
            <h4>Store</h4>
            {hackapp.store}
            <br />
            <h4>Version</h4>
            {hackapp.version}
            <br />

            {getBugs(hackapp.bugs)}
        </div>
    );
};

export default HackApp;
